import React from "react";
import { Alert, Box, Typography, CircularProgress } from "@mui/material";
import { useCurrentDroughtDeclarations } from "./useCurrentDroughtDeclarations";

export default function CurrentDroughtAlert({ ids = [] }) {
  const { data, isLoading, isError } = useCurrentDroughtDeclarations(ids);

  if (isLoading) {
    return (
      <Box my={2} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }
  if (isError) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        Failed to load current drought stage.
      </Alert>
    );
  }
  if (!data || data.length === 0) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        No current drought declarations found.
      </Alert>
    );
  }

  return (
    <Box>
      {data.map((item) => {
        const zoneName = item.zone_desc || "Unknown Zone";
        const stageName = item.stage_label || "Unknown Stage";
        const curtailment = +item.curtailment_pct || 0;

        let severity = "info";
        if (curtailment === 0) {
          severity = "success"; // blue
        } else if (curtailment === 10 || curtailment === 20) {
          severity = "warning"; // green
        } else if (curtailment >= 30) {
          severity = "error"; // red
        }

        return (
          <Alert
            key={
              item.declaration_ndx ?? `${item.zone_ndx}-${item.effective_from}`
            }
            severity={severity}
            sx={{ mb: 2 }}
          >
            <Typography variant="body2">
              <strong>Drought Zone:</strong> {zoneName}
            </Typography>
            <Typography variant="body2">
              <strong>Stage:</strong> {stageName}
            </Typography>
            {typeof item.curtailment_pct === "number" && (
              <Typography variant="body2">
                <strong>Curtailment:</strong> {item.curtailment_pct}%
              </Typography>
            )}
            {/*{item.effective_from && (*/}
            {/*  <Typography variant="body2">*/}
            {/*    <strong>Effective:</strong>{" "}*/}
            {/*    {new Date(item.effective_from).toLocaleDateString()}*/}
            {/*  </Typography>*/}
            {/*)}*/}
          </Alert>
        );
      })}
    </Box>
  );
}
